<template>
    <div>


        <el-form ref="form" :model="form" label-width="80px" class="subjectList">
            <el-form-item label="门店">
                <el-input v-model="form.name" placeholder="请输入客户或门店名称"></el-input>
            </el-form-item>
            <el-form-item label="地址">
                <el-input v-model="form.address" placeholder="请输入服务地址"></el-input>
            </el-form-item>
            <el-form-item label="内容">
                <el-input v-model="form.comments" placeholder="请输入服务内容"></el-input>
            </el-form-item>
            <el-form-item label="接单日期">
                <el-date-picker
                        v-model="form.startDate"
                        type="date"
                        :picker-options="beforPickerOptions"
                        placeholder="选择日期">
                </el-date-picker>
                <!--<span :class="$style.font">  至  </span>-->
                <span style="padding: 10px">  至  </span>
                <el-date-picker
                        v-model="form.endDate"
                        type="date"
                        :picker-options="afterPickerOptions"
                        placeholder="选择日期"
                >
                </el-date-picker>
            </el-form-item>

            <el-form-item label="状态">
                <template>
                    <el-checkbox-group v-model="form.statusList">
                        <el-checkbox label="未接单"></el-checkbox>
                        <el-checkbox label="已派单"></el-checkbox>
                        <el-checkbox label="已接单"></el-checkbox>
                        <el-checkbox label="进行中"></el-checkbox>
                        <el-checkbox label="已完工"></el-checkbox>
                        <el-checkbox label="已评价"></el-checkbox>
                    </el-checkbox-group>
                </template>
            </el-form-item>
        </el-form>
        <el-row style="margin-top: -10px">
            <el-button type="primary" size="small" @click.stop="handleQueryClick">查询</el-button>
            <el-button type="danger" size="small" @click.stop="handleResetClick">重置</el-button>
        </el-row>

        <div style="width: 100%; height: 0px; margin-top: 20px;border:1px dashed gainsboro"></div>

        <div style="margin-top: 10px">
            <el-row>
                <el-col :span="12" align="left">
                   <div style="margin-top: 15px">
                       <el-button  type="success" size="small" icon="el-icon-plus"
                                   @click.stop="addNewAction">创建工单
                       </el-button>
                       <el-button  type="warning" size="small"
                                   @click.stop="serviceManageAction">服务商管理
                       </el-button>
                   </div>
                </el-col>
                <el-col :span="12" align="right">
                    <el-row>

                        <div style="display: flex; justify-content: flex-end;" align="right">
                            <div style="height: 60px; width: 90px; border-width: 2px; background-color: white;
        border-radius: 0px; border:2px solid #4a90e2; margin-right: 10px">
                                <div align="left">
                                    <div style="color: #4a90e2; margin-top: 10px; margin-left: 10px; font-size: 11px">
                                        本月新增
                                    </div>
                                </div>
                                <div align="center">
                                    <div style="color: #4a90e2; margin-top: 5px; font-size: 20px">{{this.newCount}}
                                    </div>
                                </div>
                            </div>

                            <div style="height: 60px; width: 90px; border-width: 2px; background-color: white;
        border-radius: 0px; border:2px solid #68c235;  margin-right: 10px">
                                <div align="left">
                                    <div style="color: #68c235; margin-top: 10px; margin-left: 10px; font-size: 11px">
                                        本月完成
                                    </div>
                                </div>
                                <div align="center">
                                    <div style="color: #68c235; margin-top: 5px; font-size: 20px">{{this.completed}}
                                    </div>
                                </div>
                            </div>
                            <div style="height: 60px; width: 90px; border-width: 2px; background-color: white;
        border-radius: 0px; border:2px solid #ff9901;  margin-right: 10px">
                                <div align="left">
                                    <div style="color: #ff9901; margin-top: 10px; margin-left: 10px; font-size: 11px">
                                        进行中
                                    </div>
                                </div>
                                <div align="center">
                                    <div style="color: #ff9901; margin-top: 5px; font-size: 20px">{{this.confirmed}}
                                    </div>
                                </div>
                            </div>

                            <div style="height: 60px; width: 90px; border-width: 2px; background-color: white;
        border-radius: 0px; border:2px solid #f167f0">
                                <div align="left">
                                    <div style="color: #f167f0; margin-top: 10px; margin-left: 10px; font-size: 11px">
                                        派单中
                                    </div>
                                </div>
                                <div align="center">
                                    <div style="color: #f167f0; margin-top: 5px; font-size: 20px">{{this.unconfirmed}}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </el-row>
                </el-col>
            </el-row>

        </div>


        <el-table
                :data="thirdData"
                border
                stripe
                style="width: 100%; margin-top: 10px"
                :default-sort="{prop: 'startTime', order: 'descending'}"
        >
            <el-table-column
                    property="rowindex"
                    label="序号"
                    width="60px"
            >
            </el-table-column>
            <el-table-column
                    property="store_name"
                    label="门店"
                    sortable
                    min-width="210"
            >
            </el-table-column>

            <el-table-column
                    property="address"
                    label="地址"
                    sortable
                    min-width="210"
            >
            </el-table-column>

            <el-table-column
                    property="title"
                    label="标题"
                    sortable
                    min-width="210"
            >
            </el-table-column>
            <el-table-column
                    property="comments"
                    label="内容"
                    sortable
                    min-width="210"
            >
            </el-table-column>

            <el-table-column
                    property="alias"
                    label="服务人员"
                    sortable
                    min-width="210"
            >
            </el-table-column>
            <el-table-column
                    property="accepted_date"
                    label="接单时间"
                    sortable
                    min-width="210"
            >
            </el-table-column>
            <el-table-column
                    property="status"
                    label="状态"
                    sortable
                    min-width="210"
            >
                <template slot-scope="scope">
                    <!--<span style="color: orange">{{scope.row.status}}</span>-->
                    <!--</template>-->
                    <span v-if="scope.row.status=='NEW'"
                          style="color:red">尚未派单</span>
                    <span v-else-if="scope.row.status=='DISPATCHED'"
                          style="color:orange">等待接单</span>
                    <span v-else-if="scope.row.status=='REFUSED'"
                          style="color:orange">拒绝接单</span>
                    <span v-else-if="scope.row.status=='ACCEPTED'"
                          style="color:orange">确认接单</span>
                    <span v-else-if="scope.row.status=='VACANT_ORDER'"
                          style="color:orange">无人接单</span>
                    <span v-else-if="scope.row.status=='LIST_UNCONFIRMED'"
                          style="color:orange">服务清单确认中</span>
                    <span v-else-if="scope.row.status=='LIST_CONFIRMED'"
                          style="color:orange">服务清单已确认</span>
                    <span v-else-if="scope.row.status=='LIST_REJECTED'"
                          style="color:orange">服务清单被退回</span>
                    <span v-else-if="scope.row.status=='QUOTATION_UNCONFIRMED'"
                          style="color:orange">报价单确认中</span>
                    <span v-else-if="scope.row.status=='QUOTATION_CONFIRMED'"
                          style="color:orange">报价单已确认</span>
                    <span v-else-if="scope.row.status=='QUOTATION_REJECTED'"
                          style="color:orange">报价单被退回</span>
                    <span v-else-if="scope.row.status=='REPORT_UNCONFIRMED'"
                          style="color:orange">完工单确认中</span>
                    <span v-else-if="scope.row.status=='REPORT_CONFIRMED'"
                          style="color:orange">完工单已确认</span>
                    <span v-else-if="scope.row.status=='REPORT_REJECTED'"
                          style="color:orange">完工单被退回</span>
                    <span v-else-if="scope.row.status=='COMPLETED'"
                          style="color:orange">已完成</span>
                    <span v-else-if="scope.row.status=='CLOSED'"
                          style="color:orange">已关闭</span>
                    <span v-else-if="scope.row.status=='SERVICE_REFUSED'"
                          style="color:orange">客服拒绝此工单</span></template>
            </el-table-column>
            <el-table-column
                    fixed="right" label="操作"
                    width="80"
            >
                <template slot-scope="scope">
                    <el-button
                            type="warning" size="small"
                            @click="info(scope.$index, scope.row)">详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import http from '../../../APIService/http'

    export default {
        props: {

        },
        components: {},
        data() {
            return {
                newCount: "0",
                completed: "0",
                confirmed: "0",
                unconfirmed: "0",

                thirdData: [],
                form: {
                    name: "",
                    address: "",
                    comments: "",
                    startDate: "",
                    endDate: "",
                    statusList: []
                },
                beforPickerOptions: {
                    disabledDate: (time) => {
                        let endDate = new Date(this.form.endDate)
                        endDate.setHours(0)
                        endDate.setMinutes(0)
                        endDate.setSeconds(0)

                        if (endDate) {
                            return time.getTime() > endDate
                        }
                    }
                },
                afterPickerOptions: {

                    disabledDate: (time) => {
                        let startDate = new Date(this.form.startDate)
                        startDate.setHours(0)
                        startDate.setMinutes(0)
                        startDate.setSeconds(0)

                        if (startDate) {
                            return time.getTime() < startDate
                        }
                    }
                },
            }
        },
        computed: {},
        created() {

            var listServiceSheet = this.$store.getters.getListServiceSheet
            this.form.name =  listServiceSheet.name
            this.form.address =  listServiceSheet.address
            this.form.comments =  listServiceSheet.comments
            this.form.startDate =  listServiceSheet.startDate
            this.form.endDate =  listServiceSheet.endDate
            this.form.statusList =  listServiceSheet.statusList

        },
        methods: {

            getData(row) {
                this.thirdData = row.data
                this.newCount = row.newCount
                this.completed = row.completed
                this.confirmed = row.confirmed
                this.unconfirmed = row.unconfirmed
            },
            getInfo(){

              return {
                  name : this.form.name,
                  address : this.form.address,
                  comments : this.form.comments,
                  startDate : this.form.startDate,
                  endDate : this.form.endDate,
                  statusList : this.form.statusList,
              }
            },
            addNewAction (){
                this.$emit('addNewAction')

            },
            serviceManageAction (){
                this.$emit('serviceManageAction')
            },

            info(index, row) {
                this.$router.push({
                    path: '/workOrderInfo',
                    query: {
                        ticket_id: row.ticket_id,
                        store_name: row.store_name,
                        address: row.address
                    }
                })
            },
            handleQueryClick() {


                this.$emit('queryAction')

//                this.listServiceSheet = this.$store.getters.getListServiceSheet
//                if (this.listServiceSheet == null){
//                    this.$store.commit('resetListServiceSheet')
//                    this.listServiceSheet = this.$store.getters.getListServiceSheet
//                }
//                this.listServiceSheet.current3 = 1
//                this.listServiceSheet.size = 5
                var listServiceSheet = {}
                listServiceSheet.name = this.form.name
                listServiceSheet.address = this.form.address
                listServiceSheet.comments = this.form.comments
                listServiceSheet.startDate = this.form.startDate
                listServiceSheet.endDate = this.form.endDate
                listServiceSheet.statusList = this.form.statusList

                this.$store.commit('setListServiceSheet',listServiceSheet)

            },
            handleResetClick() {

                this.form.name = "";
                this.form.address = "";
                this.form.startDate = "";
                this.form.endDate = "";
                this.form.statusList = [];
                this.form.comments = "";

                var listServiceSheet = {}
                listServiceSheet.name = ''
                listServiceSheet.address = ''
                listServiceSheet.comments = ''
                listServiceSheet.startDate = ''
                listServiceSheet.endDate = ''
                listServiceSheet.statusList = []

                this.$store.commit('setListServiceSheet',listServiceSheet)

            },

        }
    }
</script>

<style lang="scss" module>
    @import '../../../assets/css/default';



</style>
<style scoped>

    .subjectList >>> .el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/tableList/thirdTable.vue